import Modal from 'utils/packages/Modal';
const AccountLinkedToAutosaveModal = {
    show: (navigateToAutosave, type) => {
        const text = type === 'close' ? 'close this account' : 'change this account type';
        Modal.showConfirmation({
            title: 'This account is linked to Autosave',
            subtitle: `To ${text}, you’ll first need to choose a different account to use for your Emma Autosave`,
            confirmButtonTitle: 'Okay',
            cancelButtonTitle: 'Manage Autosave',
            onPressCancel: navigateToAutosave,
        });
    },
    hide: Modal.hide,
};
export default AccountLinkedToAutosaveModal;
